import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FORMAT_EXCEPTION_FIELD_TYPES } from "src/app/features/bizzmine/form/constants/form-constants";
import { getDisplayStyleForNumber } from "src/app/shared/functions/helpers/display-style-helpers";
import { CollectionFieldDisplayStyleValueDto } from "src/models/ts/collection-field-display-style-value-dto.model";
import { CollectionFormField } from "src/models/ts/collection-form-field.model";
import { UserSettingsDto } from "src/models/ts/user-settings-dto.model";

@Component({
	selector: "bizz-report-numeric-control",
	standalone: true,
	imports: [CommonModule],
	templateUrl: "./report-numeric-control.component.html",
	styleUrl: "./report-numeric-control.component.scss",
})
export class ReportNumericControlComponent implements OnInit {
	@Input() public field: CollectionFormField;
  @Input() public userSettings: UserSettingsDto;
	public backgroundColor: string | undefined;
	public foregroundColor: string | undefined;
	public value: string | undefined;

	public ngOnInit(): void {
    if(this.field){
      
      if (!FORMAT_EXCEPTION_FIELD_TYPES.includes(this.field.ProtectedFieldType)) {
      const styling = this.getDisplayStyleForNumber(this.field);
      if (styling) {
        this.backgroundColor = styling?.BackgroundColor;
        this.foregroundColor = styling?.ForegroundColor;
      }
        this.value = this.field.Value ? this.formatNumber(this.field.Value, this.field.MaxDecimals) : undefined;
      }else{
        this.value = this.field.Value;
      }
    }
	}

	/**
	 * Formats a given number with a specified maximum number of decimal places,
	 * applying thousands and decimal separators based on user settings.
	 *
	 * @param number - The number to format.
	 * @param maxDecimals - The maximum number of decimal places to include.
	 * @returns A string representation of the formatted number with the appropriate
	 *          thousands and decimal separators.
	 */
	public formatNumber(number: number, maxDecimals: number): string {
		const roundedNum = number.toFixed(maxDecimals);
		const [integerPart, decimalPart] = roundedNum.split(".");
		const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, this.userSettings?.ThousandSeparatorString);
		if (decimalPart !== undefined) {
			return `${formattedInteger}${this.userSettings?.DecimalSeparatorString}${decimalPart}`;
		} else {
			return `${formattedInteger}`;
		}
	}

  public getDisplayStyleForNumber(field: CollectionFormField): CollectionFieldDisplayStyleValueDto | null {
    if (!field.Value) {
      return null;
    } else {
      const selectedValue = getDisplayStyleForNumber(field.DisplayStyleValues, field.Value);
      if (selectedValue !== null)
        return selectedValue;
      else {
        return null;
      }
    }
  }

}
